import { Injectable } from '@angular/core';
import { BaseDataService } from 'src/app/core/service/base-data.service';
import { VirtualUser } from '../models/common-data.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VirtualUserService {
  private apiUserInformationUrl = 'api/UserInformation';

  constructor(public baseDataService: BaseDataService) {}

  createVirtualUser(
    virtualUserReq: VirtualUser,
    companyId: string
  ): Observable<boolean> {
    return this.baseDataService.makePostCall(
      `${this.apiUserInformationUrl}/createVirtualUserAsync?companyProfileId=${companyId}`,
      virtualUserReq
    );
  }

  updateVirtualUser(virtualUserReq: VirtualUser): Observable<boolean> {
    return this.baseDataService.makePutCall(
      `${this.apiUserInformationUrl}/updateVirtualUser`,
      virtualUserReq
    );
  }

  getVirtualUser(companyId: string): Observable<VirtualUser[]> {
    return this.baseDataService.makeGetCall(
      `${this.apiUserInformationUrl}/getVirtualUser?companyProfileId=${companyId}`
    );
  }
}
